module.exports = __webpack_public_path__ + "img/maison23.56f9fa34.jpg";